import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Printer, Loader2 } from "lucide-react";

// Fiche A4 de la fable : texte, portraits des personnages, morale et question.
export default function FableSheetButton({ story, compact = false }) {
  const [busy, setBusy] = useState(false);
  if (story.kind !== "fable") return null;
  const print = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/stories/${story.id}/fable-sheet.pdf`, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data);
      a.download = `fiche-${story.title}.pdf`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch { toast.error("Fiche indisponible pour le moment."); }
    finally { setBusy(false); }
  };
  if (compact) return (
    <button onClick={print} disabled={busy} data-testid={`fable-print-${story.id}`} title="Imprimer la fiche de la fable"
      className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg border border-amber-300 text-amber-800 text-sm font-medium hover:bg-amber-50 transition-colors">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Printer className="w-4 h-4" />} Fiche
    </button>
  );
  return (
    <button onClick={print} disabled={busy} data-testid="fable-print-button"
      className="mt-6 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-white border-2 border-amber-300 text-amber-800 font-patient font-bold hover:bg-amber-50 transition-colors">
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Printer className="w-5 h-5" />} Imprimer la fiche de la fable
    </button>
  );
}
